import { socialApi } from './shared';

/** Hand-authored Instagram endpoint copy and examples. */
export const INSTAGRAM = socialApi({
  id: 'instagram',
  name: 'Instagram',
  blurb:
    'Public Instagram profiles and posts as structured JSON: pass a handle, get a normalized payload back. One key, one wallet, billed per request in real dollars.',
  endpoints: {
    profile: {
      description: 'Public profile for a handle: name, bio, category, follower/following counts and avatar.',
      input: { handle: 'nasa' },
      sample: {
        handle: 'nasa',
        displayName: 'NASA',
        bio: 'Exploring the universe and our home planet.',
        category: 'Science',
        verified: true,
        followers: 97_400_000,
        following: 78,
        posts: 4_120,
        avatarUrl: 'https://instagram.com/nasa/avatar.jpg',
        externalUrl: 'https://www.nasa.gov',
      },
    },
    user_posts: {
      description: 'Paginated grid of a profile’s posts and reels with captions, media URLs and engagement. Paginate with the cursor field.',
      input: { handle: 'nasa', cursor: '0' },
      sample: {
        nextCursor: 'QVFEX2Z',
        posts: [
          {
            id: '3401000000000000000',
            url: 'https://www.instagram.com/p/C8aBcDeFgHi/',
            caption: 'A new view of the Pillars of Creation.',
            likes: 1_840_000,
            comments: 9_200,
            createdUtc: 1_717_945_200,
            username: 'nasa',
            verified: true,
          },
        ],
      },
    },
    post: {
      description: 'A single Instagram post or reel by URL: id, shortcode, type, owner, like count and media URLs.',
      input: { url: 'https://www.instagram.com/p/C8aBcDeFgHi/' },
      sample: {
        id: '3401000000000000000',
        shortcode: 'C8aBcDeFgHi',
        type: 'XDTGraphVideo',
        owner: 'nasa',
        likes: 1_840_000,
        displayUrl: 'https://instagram.com/p/C8aBcDeFgHi/media.jpg',
        videoUrl: 'https://instagram.com/p/C8aBcDeFgHi/media.mp4',
      },
    },
    user_reels: {
      description: 'List a profile’s reels by handle with cursor pagination: caption, plays, likes and comments.',
      input: { handle: 'nasa' },
      sample: {
        nextCursor: 'QVFEX2Z',
        reels: [
          {
            id: '3641924023820356866',
            shortcode: 'DKKtpqaxg0C',
            caption: 'A flyby of the Pillars of Creation 🌌',
            views: 2_410_000,
            likes: 184_000,
            comments: 1_920,
            createdUtc: 1_748_371_310,
            username: 'nasa',
            verified: true,
            durationSeconds: 30.4,
          },
        ],
      },
    },
    post_comments: {
      description: 'List the comments on a post or reel by URL with cursor pagination: text, author, verification and like count.',
      input: { url: 'https://www.instagram.com/p/C8aBcDeFgHi/' },
      sample: {
        comments: [
          {
            id: '18051843701642870',
            text: 'Incredible shot 🔭',
            author: 'spacefan',
            verified: false,
            likes: 42,
            createdAt: '2025-09-16T17:03:04.000Z',
          },
        ],
      },
    },
    search_hashtag: {
      action: 'Hashtag search',
      description: 'Recent posts under a hashtag with cursor pagination: shortcode, type, caption and media URL.',
      input: { hashtag: 'spacex' },
      sample: {
        posts: [
          {
            id: '3714950709444987377',
            shortcode: 'DOOJ_zSjcnx',
            type: 'XDTGraphVideo',
            url: 'https://www.instagram.com/reel/DOOJ_zSjcnx/',
            caption: 'Launch day! 🚀 #spacex',
            displayUrl: 'https://instagram.com/reel/DOOJ_zSjcnx/media.jpg',
          },
        ],
      },
    },
  },
});
